export const truncateText = (text: string, maxLength: number): string => {
    if (text.length <= maxLength) return text;
    let truncated = text.slice(0, maxLength);
    while (truncated.length > 0 && !/\s/.test(truncated[truncated.length - 1])) {
        truncated = truncated.slice(0, -1);
    }

    return truncated.trim() + '...';
};
